<template>
  <PopupForm
    :show="show"
    title="Create Sub Lot"
    @confirm="createSubLot"
    @close="close"
  >
    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <label>Location:</label>
      <select
        v-model="locationId"
        name="location_id"
      >
        <template v-for="location in locations">
          <option :value="location.id">{{ location.name }}</option>
        </template>
      </select>
    </div>

    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <label>Space:</label>
      <select
        v-model="form.space_id"
        name="space_id"
      >
        <option :value="null">Select a Space</option>
        <template v-for="space in spaceList">
          <option :value="space.id">{{ space.name }}</option>
        </template>
      </select>
      <div v-if="form.errors.space_id">{{ form.errors.space_id }}</div>
    </div>

    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <label>Sub-Lot:</label>
      <select
        v-model="form.sub_lot_num"
        name="sub_lot_num"
      >
        <option :value="null">Select Sub-Lot</option>
        <template v-for="val in subLotNums">
          <option :value="val">{{ val }}</option>
        </template>
      </select>
      <div v-if="form.errors.sub_lot_num">{{ form.errors.sub_lot_num }}</div>
    </div>

    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <label>Quantity:</label>
      <input
        type="number"
        v-model="form.quantity"
      />
      <div v-if="form.errors.quantity">{{ form.errors.quantity }}</div>
    </div>
  </PopupForm>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { getHeadersWithToken } from '@/utils/http'
import { useForm } from '@inertiajs/vue3'
import PopupForm from '@/Components/Forms/PopupForm.vue'

const emit = defineEmits(['close'])

const props = defineProps({
  show: {
    type: Boolean
  },
  src: {
    type: String,
    default() {
      return null
    }
  },
  package: {
    type: Object
  },
  locations: {
    type: Array,
    default() {
      return []
    }
  },
  spaces: {
    type: Array,
    default() {
      return []
    }
  }
})

const form = useForm({
  space_id: null,
  sub_lot_num: null,
  quantity: null
})

const locationId = ref(null)
const subLotNums = ref([])

const locationList = computed(() => {
  return [{ name: 'Select Location', id: null }, ...props.locations]
})

const spaceList = computed(() => {
  if (!locationId.value) {
    return []
  }

  return props.spaces.filter((space) => space.location_id === locationId.value)
})

watch(locationId, async (newVal, oldVal) => {
  form.space_id = null
  await fetchSubLotOptions()
})

watch(form.space_id, async (newVal, oldVal) => {
  await fetchSubLotOptions()
})

const fetchSubLotOptions = async () => {
  const response = await fetch(
    route('api.packages.sub_lot_options', {
      packages: [props.package.id],
      location_id: locationId.value,
      space_id: form.space_id
    }),
    {
      headers: getHeadersWithToken(),
      method: 'get'
    }
  )

  let options = await response.json()
  subLotNums.value = options[props.package.id] || []
}

const createSubLot = async () => {
  await form.post(props.src)
  close()
}

const close = () => {
  form.reset()
  emit('close')
}
</script>
